<template>
  <div :class="$style.zoom_slider">
    <div :class="[$style.wrap, exportZoom ? $style.wrap_export : '']">
      <label
        :class="$style.label"
        :style="{width: zoomSize}"
      >
        <div :class="[$style.dots, exportZoom ? $style.dots_export : '']">
          <div
            v-for="dot in dots"
            :key="dot"
            :class="$style.dot"
          />
        </div>
        <input
          :class="$style.slider"
          type="range"
          step="1"
          min="0"
          max="5"
          :value="zoom"
          @change="onChange"
        >
      </label>
    </div>
    <div :class="[$style.title, exportZoom ? $style.title_export : '']">
      {{ title }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    value: {
      type: Number,
      default: 1,
    },
    zoomSize: {
      type: String,
      default: '104px',
    },
    exportZoom: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'onChange',
  ],
  data() {
    return {
      zoomTitles: [
        __('zoom_scale_hours'),
        __('zoom_scale_days'),
        __('zoom_scale_weeks'),
        __('zoom_scale_months'),
        __('zoom_scale_quarters'),
        __('zoom_scale_years'),
      ],
      zoom: this.value,
    };
  },
  computed: {

    dots() {
      return this.zoomTitles.slice(0);
    },
    title() {
      return this.zoomTitles[this.zoom];
    },
  },
  watch: {
    value(val) {
      this.zoom = val;
    },
  },
  methods: {
    onChange(e) {
      this.zoom = +e.target.value;
      const debouncedHandler = _.debounce(value => {
        this.$emit('onChange', value);
      }, 300);

      debouncedHandler(this.zoom);

      function defineTimeUnit(val) {
        switch (val) {
        case 0: return 'hours';
        case 1: return 'days';
        case 2: return 'weeks';
        case 3: return 'months';
        case 4: return 'quarters';
        case 5: return 'years';
        default: return val;
        }
      }

      userExtAnalytics.log('gantt_zoom_changed', {
        'new value': defineTimeUnit(this.zoom),
      });
    },
  },
};
</script>

<style module lang="less" src="../less/zoomSlider.less"></style>
